module.exports = __webpack_public_path__ + "static/ss7.452c7e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss7.png
// module id = 1203
// module chunks = 81679748166845